import EF from 'ef/ef';
import utils from 'lib/utils';
import Chaplin from 'chaplin';

const Poll = Chaplin.Model.extend({
  fileName: function () {
    return `polls/${this.get('slug')}.json`;
  },

  url: function () {
    return EF.ContentProvider.PollService.getUrl(this);
  },

  parse: function (response) {
    if (EF.options.local && response && response.data) {
      const pollData = utils.sanifyJsonApiObject(response.data, response.included);
      utils.setSectionsData(pollData);
      //SDK polls expect only one section/question for now
      const sectionIndex = this.get('sectionIndex') || 0;
      const questionIndex = this.get('questionIndex') || 0;
      return pollData.sections[sectionIndex].questions[questionIndex];
    } else {
      return EF.ContentProvider.PollService.parse(this, response);
    }
  },

  save: function (attrs, options) {
    return EF.ContentProvider.PollService.save(this, options);
  },

  initialize: function (attrs) {
    this.set('poll_key', attrs.slug);
    this.set('course_key', 'ef_test');
  },
});

export default Poll;
